import * as React from "react";
import UnstyledButton from "../UnstyledButton/UnstyledButton";
import Visage2Icon from "src/visage2/Visage2Icon/Visage2Icon";
import { Colors, Text } from "src/components/Text";
import "./CalypsoButton.scss";

interface IProps {
    title: string;
    text?: string;
    icon?: string;
    onClick?: any;
    theme?: "light" | "primary";
    classNames?: string[];
    reversed?: boolean;
    iconType?: "bold" | "outline" | "custom" | undefined;
    iconColor?: spintrColors;
    textColor?: Colors;
}

const CalypsoButton = (props: IProps) => {
    const isColored = props.theme === "primary";

    return (
        <UnstyledButton
            className={
                [
                    ...(props.classNames || []),
                    "CalypsoButton",
                    !props.text ? "icon-only" : "",
                    isColored ? "primaryBGColor" : "",
                    props.reversed ? "reversed" : "",
                    props.icon?.toLowerCase() === "add" ? "add-button" : ""
                ].filter(x => x).join(" ")
            }
            title={props.title}
            onClick={props.onClick}>
            {props.icon && <div className="icon-wrapper">
                <Visage2Icon type={props.iconType || "outline"} icon={props.icon} color={props.iconColor || (isColored ? "white" : "dark-grey")} size={props.icon === "add" ? "medium" : "small"} />
            </div>}
            {props.text && <Text size="caption" color={props.textColor || (isColored ? "white" : "grayDark")}>{props.text}</Text>}
        </UnstyledButton>
    )
}

export default CalypsoButton;
